import { forwardRef } from 'react';

// Time-of-day (HH:MM) control for calendar scheduling. Unlike TimePicker, which edits an
// elapsed duration, this wraps the native time input so keyboard, locale and assistive
// technology support come from the browser. Works with react-hook-form's register().
const TimeOfDayInput = forwardRef(function TimeOfDayInput(
    { id, label, className = '', step = 60, ...rest },
    ref
) {
    const input = (
        <input
            ref={ref}
            id={id}
            type='time'
            step={step}
            className={`form-control ${className}`.trim()}
            {...rest}
        />
    );

    if (!label) return input;

    return (
        <>
            <label htmlFor={id}>{label}</label>
            {input}
        </>
    );
});

export default TimeOfDayInput;
